import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import LinkCopyBox from "../../../../_shoru_shared_library/components/console_page/LinkCopyBox";

function BookingOverviewTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;

  const bookingPage = window.location.origin + '/' + userData.active_organisation_id + '/' + castingData.uid;

  return (
    <SubTabParent passData={props}>

      <SubTabSection title='Booking Page' description='Visitors can book an audition through your Booking Page'>
        <LinkCopyBox url={bookingPage} />
      </SubTabSection>

    </SubTabParent>
  )

}

export default BookingOverviewTab;